module.exports = __webpack_public_path__ + "static/img/bg-default-pc.19e1140e.png";